import { apiGet } from '../api';

export interface BillingRewardsSummary {
  wallet: {
    enabled?: boolean;
    available_points?: number;
    reserved_points?: number;
    redemption_enabled?: boolean;
    points_per_ngn?: number;
    withdrawable?: boolean;
  };
  referral: {
    enabled?: boolean;
    message?: string;
    referral_code?: string;
    referral_link?: string;
    summary?: {
      qualified?: number;
      verified?: number;
      total_attributed?: number;
    };
    rewards?: {
      available_balance?: number;
      earned_points?: number;
      message?: string;
    };
  };
  paths?: {
    referrals?: string;
    subscription?: string;
    pricing?: string;
  };
}

export async function fetchBillingRewardsSummary(): Promise<BillingRewardsSummary | null> {
  const res = await apiGet<{ success: boolean; data: BillingRewardsSummary }>('/account/billing-summary');
  return res.success ? res.data : null;
}
